// Component
import { Button, UncontrolledTooltip } from "reactstrap"

// Icon
import { FiTrash2 } from "react-icons/fi"

export const DeleteButton = ({ onClick, id }) => (
	<>
		<Button
			className='btn-icon'
			color='danger'
			onClick={onClick}
			id={`deletebutton-${id}`}
			size="sm"
		>
			<FiTrash2 size={14} className="text-light" />
		</Button>

		<UncontrolledTooltip placement='top' target={`deletebutton-${id}`}>
			Delete Data
		</UncontrolledTooltip>
	</>
)